import { jsx } from 'react/jsx-runtime';

/**
Il ButtonGroup serve per raggruppare un insieme di bottoni spaziandoli corretamente tra di loro ed evitando l'effetto assembramento
 */
function ButtonGroup({ children }) {
    return (jsx("div", { className: "buttonGroup", children: children }));
}

export { ButtonGroup as default };
